"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Methods = void 0;
var Methods;
(function (Methods) {
    Methods["sendTransactions"] = "sendTransactions";
    Methods["rpcCall"] = "rpcCall";
    Methods["getChainInfo"] = "getChainInfo";
    Methods["getSafeInfo"] = "getSafeInfo";
    Methods["getTxBySafeTxHash"] = "getTxBySafeTxHash";
    Methods["getSafeBalances"] = "getSafeBalances";
    Methods["signMessage"] = "signMessage";
    Methods["getEnvironmentInfo"] = "getEnvironmentInfo";
})(Methods = exports.Methods || (exports.Methods = {}));
//# sourceMappingURL=methods.js.map